import { render, staticRenderFns } from "./box-firma.vue?vue&type=template&id=1c1ac529&scoped=true&lang=html"
import script from "./box-firma.vue?vue&type=script&lang=js"
export * from "./box-firma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1ac529",
  null
  
)

export default component.exports